export default __webpack_public_path__ + "static/media/dice-animation.3dc6cfb6.webp";